import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, LoadingController, NavController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { HttpService } from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})

export class UtilService {

    userid: BehaviorSubject<string> = new BehaviorSubject<string>("");

    listOfStates = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

    constructor(
        public loadingController: LoadingController,
        private router: Router,
        private nav: NavController,
        public alertController: AlertController,
        private httpService: HttpService
    ) {
        this.getUserId();
    }

    getUserId() {
        /*
        this.fireAuth.auth.onAuthStateChanged(user => {
          this.userid.next(user.uid);
        })
        */
    }

    navigate(link, forward?) {
        if (forward) {
            this.nav.navigateForward('/' + link);
        }
        else {
            this.router.navigateByUrl('/' + link);
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    validaCPF(cpf) {

        //console.log('Validando CPF: ' + cpf);

        cpf = cpf.replace(/[^\d]+/g, '');

        if (cpf == '' || cpf.length != 11) {
            return false;
        }

        // Elimina CPFs invalidos conhecidos
        if (cpf.length != 11 ||
            cpf == "00000000000" ||
            cpf == "11111111111" ||
            cpf == "22222222222" ||
            cpf == "33333333333" ||
            cpf == "44444444444" ||
            cpf == "55555555555" ||
            cpf == "66666666666" ||
            cpf == "77777777777" ||
            cpf == "88888888888" ||
            cpf == "99999999999") {

            return false;
        }

        var add = 0;
        var i;
        var rev = 0;

        // Valida 1o digito
        for (i = 0; i < 9; i++) {
            add += parseInt(cpf.charAt(i)) * (10 - i);
            rev = 11 - (add % 11);
        }

        if (rev == 10 || rev == 11) {
            rev = 0;
        }

        if (rev != parseInt(cpf.charAt(9))) {
            return false;
        }

        // Valida 2o digito
        add = 0;

        for (i = 0; i < 10; i++) {
            add += parseInt(cpf.charAt(i)) * (11 - i);
            rev = 11 - (add % 11);
        }

        if (rev == 10 || rev == 11) {
            rev = 0;
        }

        if (rev != parseInt(cpf.charAt(10))) {
            return false;
        }

        return true;
    }

    validaLinha(linha) {

        //console.log('Validando Linha: ' + linha);

        linha = linha.replace(/[^\d]+/g, '');

        if (linha === '' || linha.length !== 11) {
            return false;
        }

        // Testa DDDs Válidos

        // const ddd = linha.substr(0, 2);

        //console.log('DDD: ' + ddd);

        return true;
    }

    validaCEP(cep) {

        //console.log('CEP:' + cep);

        if (cep === '') {
            return false;
        }

        cep = cep.replace(/[^\d]+/g, '');

        if (cep.length !== 8) {
            return false;
        }

        return true;
    }


    async openLoader() {
        const loading = await this.loadingController.create({
            message: 'Please Wait ...',
            duration: 2000
        });
        await loading.present();
    }

    async closeLoading() {
        return await this.loadingController.dismiss();
    }

    getLocalUrl(_imagePath): Promise<{ url: string, nativeUrl: string }> {
        return new Promise((resolve, reject) => {
            let name = _imagePath.split('/');
            this.makeFileIntoBlob(_imagePath, name[name.length - 1]).then((image: any) => {
                resolve({ url: window.URL.createObjectURL(image), nativeUrl: _imagePath })
            }).catch(
                _ => {
                    reject();

                }
            )
        });
    }

    makeFileIntoBlob(_imagePath, fileName) {
        return new Promise((resolve, reject) => {
            window['resolveLocalFileSystemURL'](_imagePath, (fileEntry) => {
                fileEntry['file']((resFile) => {
                    var reader = new FileReader();
                    reader.onload = (evt: any) => {
                        var imgBlob: any = new Blob([evt.target.result], { type: 'image/jpeg' });
                        imgBlob.name = fileName;
                        resolve(imgBlob);
                    };
                    reader.onloadend = (evt: any) => {
                        var imgBlob: any = new Blob([evt.target.result], { type: 'image/jpeg' });
                        imgBlob.name = fileName;
                        resolve(imgBlob);
                    };

                    reader.onerror = (e) => {

                        reject(e);
                    };

                    reader.readAsArrayBuffer(resFile);
                }, (err: any) => {
                    console.log("🚀 ~ file: util.service.ts:194 ~ UtilService ~ returnnewPromise ~ err:", err)

                    reject({ message: "File does not exists." })
                });
            }, (err: any) => {
                console.log("🚀 ~ file: util.service.ts:199 ~ UtilService ~ returnnewPromise ~ err:", err)
                debugger;

            });
        });
    }


    /**
     * Gets address by cep
     * @author Starley Cazorla
     * @param cep 
     * @returns  
     */
    getAddressByCep(cep: any) {
        return new Promise((resolve, reject) => {
            this.httpService.getExternal('https://viacep.com.br/ws/' + cep.replace(/\D/g, '') + '/json/').subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })
        })
    }

}
